import { render, staticRenderFns } from "./VenueTrainingAddress.vue?vue&type=template&id=6f036aac&scoped=true"
import script from "./VenueTrainingAddress.vue?vue&type=script&lang=js"
export * from "./VenueTrainingAddress.vue?vue&type=script&lang=js"
import style0 from "./VenueTrainingAddress.vue?vue&type=style&index=0&id=6f036aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f036aac",
  null
  
)

export default component.exports